var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"sflogo",style:(`max-width: ${_vm.scale} !important;
                height: auto !important;
                min-width: 120px;`),attrs:{"src":require("../../static/logo.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }